import { MovieStreamAudioMetaFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { transformAudio } from '../../movie-player/transformers/transform-audio';

import { useFilmOtt } from './use-film-ott';

export function useAudio(contentId: string) {
    const film = useFilmOtt(contentId);

    const metas = film?.onlineStreams?.streams?.[0]?.streamMeta?.audioMetas?.reduce<
        MovieStreamAudioMetaFragment[]
    >((acc, meta) => {
        if (meta) {
            acc.push(meta);
        }

        return acc;
    }, []);

    return transformAudio(metas || []);
}
